import { motion } from "framer-motion";

const reveal = (delay = 0) => ({
  initial: { opacity: 0, y: 40 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-80px" },
  transition: { duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] },
});

export const VideoSection = ({ t }) => (
  <section className="relative overflow-hidden border-b border-white/10" data-testid="video-section">
    <div className="pointer-events-none absolute -left-40 top-1/2 h-[50vh] w-[50vh] -translate-y-1/2 rounded-full bg-[#00e5ff]/10 blur-[140px]" />
    <div className="relative mx-auto grid max-w-[1440px] items-center gap-12 px-5 py-24 md:px-10 md:py-32 lg:grid-cols-2">
      <div>
        <motion.p {...reveal()} className="mb-6 font-mono-spec text-[11px] uppercase tracking-[0.3em] text-[#00e5ff]" data-testid="video-kicker">
          / {t.kicker}
        </motion.p>
        <motion.h2 {...reveal(0.08)} className="max-w-xl font-display text-3xl font-semibold leading-tight tracking-tight md:text-5xl" data-testid="video-title">
          {t.title}
        </motion.h2>
        <motion.p {...reveal(0.16)} className="mt-6 max-w-md text-sm leading-relaxed text-slate-400 md:text-base" data-testid="video-caption">
          {t.caption}
        </motion.p>
      </div>
      <motion.div {...reveal(0.1)} className="clipped-frame spotlight relative mx-auto w-full max-w-[340px]">
        <div className="aspect-[9/16] w-full">
          <iframe
            src={`https://www.youtube.com/embed/${t.id}`}
            title="SQB Robotics — Proximart demo"
            className="h-full w-full"
            loading="lazy"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            data-testid="video-iframe"
          />
        </div>
      </motion.div>
    </div>
  </section>
);
